import _ from '@/utils/lodash-optimized'
import { createSelector } from 'reselect'

import * as Compartment from './compartment.js'

export const getPrimaryInsuranceProvider = createSelector(
  Compartment.unmappedCoverages,
  coverages =>
    _.chain(coverages)
        .find(c => c?.primaryOrSecondary === 'primary')
      .get('provider', null)
      .value()
)

export const getPrimaryInsurancePlan = createSelector(
  Compartment.unmappedCoverages,
  coverages =>
    _.chain(coverages)
        .find(c => c?.primaryOrSecondary === 'primary')
      .get('plan', null)
      .value()
)

export const getPrimaryInsurancePlusPlan = createSelector(
  [ getPrimaryInsurancePlan, getPrimaryInsuranceProvider ],
  (plan, provider) => {
    if (plan && provider) {
      return `${provider} - ${plan}`
    }
    if (!plan) {
      return provider
    }
    return null
  }
)
